import React, { Component } from "react";
import Helmet from "react-helmet";

const SITE_NAME = "PT Pola Artistika Perkasa";

export default class helmet extends Component {
  render() {
    const { title, description, keywords, canonical } = this.props;
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;

    return (
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        {canonical && <link rel="canonical" href={canonical} />}
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        {canonical && <meta property="og:url" content={canonical} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
      </Helmet>
    );
  }
}
